import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { ListStore } from '@src/mobile/event/layout/store';
import styles from './index.css';

const LiveNotice = () => {
    const listStore = ListStore.useContainer();
    const { listStates } = listStore;
    const { live, id } = listStates;

    const [noticeText, setNoticeText] = useState(null);

    useEffect(
        () => {
            if (live) {
                const { startTime, endTime, liveUrl, showLive, notice } = live;

                if (showLive && liveUrl && startTime && endTime) {
                    const startTimeObj = dayjs(startTime);
                    const endTimeObj = dayjs(endTime);

                    if (startTimeObj.isValid() && endTimeObj.isValid()) {
                        const nowTimeObj = dayjs();

                        if (nowTimeObj.isBefore(startTimeObj)) {
                            setNoticeText(notice);
                        }
                    }
                }
            }
        },
        [live],
    );

    return noticeText ? (
        <div className={styles.wrap}>
            <div className={styles.content}>
                <span className={styles.textPrefix}>直播预告：</span>
                <span>{noticeText}</span>
            </div>
        </div>
    ) : null;
};

export default errorBoundary(LiveNotice);
